import { Component, OnInit } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';
import { StepperService } from 'src/app/core';

@Component({
  selector: 'app-modal-date-warning',
  templateUrl: './modal-date-warning.component.html',
  styleUrls: ['./modal-date-warning.component.scss'],
  standalone: false
})
export class ModalDateWarningComponent implements OnInit {
  constructor(
    private modal: BciWkModalService,
    private stepsService: StepperService
  ) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        maxWidth: '600px',
        width: '100%',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '16px',
        overflowY: 'hidden',
      },
    });
  }
  prevStep() {
    this.stepsService.prevStep();
    this.modal.close();
  }
  close() {
    this.modal.close();
  }
}
